import { useQuery } from 'react-query';
import { usersAPI } from '../services/usersApi';

// Anshul, 2026-09-26: the Navbar's Users badge -- a cheap, standalone poll (GET
// /admin/users/pending-count) rather than piggybacking on UsersPage's full list
// fetch, since the Navbar renders on every signed-in page, not just /admin/users.
// `enabled` gates it on the caller already knowing the user is an admin: a CUSTOMER
// account gets a 403 from this route, so the query must never even fire for one.
export default function usePendingApprovalsCount({ enabled }) {
  const query = useQuery(
    ['admin-users-pending-count'],
    () => usersAPI.pendingCount().then((response) => response.data.count),
    {
      enabled,
      refetchInterval: 60000,
      refetchOnWindowFocus: true,
      staleTime: 30000,
    }
  );
  return query.data || 0;
}
